export default {
  API_URL: 'https://api.painel.castelatto.com.br/',
  CLIENT_SECRET: 'sgrKIpCpJXsn4ZBTRsdpFRNnwkzl4kLxrC8nkyo5',
  GRANT_TYPE: 'password',
  CLIENT_ID: '2',
  PUSHER_APP_KEY: '66824d8739c0181af28e',
  PUSHER_APP_CLUSTER: 'mt1',
  UPLOAD_LIMIT: 5,
  GOOGLE_API_KEY: 'AIzaSyC27IQyViFB4ip6CAfIXeZbnyohxdeVEEc',
  RESELLER_ROLE_ID: 2,
  RESELLER_TYPE_ID: 3,
  REPRESENTATIVE_ROLE_ID: 3,
  REPRESENTATIVE_TYPE_ID: 4,
  COMMERCIAL_ROLE_ID: 6,
  COMMERCIAL_TYPE_ID: 4,
  TESTER_ID: 4,
  APP_ID: 525790878336932,
};
